import { css } from "@emotion/react";

export const form = css`
  display: flex;
  flex-direction: column;
`;

export const locationNote = css`
  display: flex;
  align-items: center;
  gap: 8px;
`;
